import { observer, useLocalObservable } from "mobx-react";
import DisplayMessage from "./component/DisplayMessage";
import React, { useEffect } from "react";
import AdvicePageListView from "./AdvicePageListView";
import AdvicePageStore from "./store/AdvicePageStore";
import useSnackbarMessage from "shared/snackbar";
import AdviceTopTabs from "./component/AdviceTopTabs";
import { useRootStore } from "store/StoreContextProvider";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";

function AdvicePage() {
  const pageStore = useLocalObservable(() => new AdvicePageStore());
  const snackbar = useSnackbarMessage();
  const { loginStore } = useRootStore();
  const navigate = useNavigate();

  useEffect(() => {
    fetchTargetsByDeptCode();
  }, []);

  const fetchTargetsByDeptCode = async () => {
    try {
      const res = await pageStore.fetchTargetsByDeptCode(
        loginStore.currentUser
      );
      if (res?.expired) {
        loginStore.onLogout();
        navigate("/login");
        return;
      }
    } catch (err: any) {
      snackbar.error(err.message);
    }
  };
  return (
    <>
      <AdviceTopTabs pageStore={pageStore} />
      <DisplayMessage />

      <Grid style={{ padding: "20px 20px 80px 20px" }}>
        <AdvicePageListView pageStore={pageStore} />
      </Grid>
    </>
  );
}

export default observer(AdvicePage);
